import React from "react";

import StarIcon from "@mui/icons-material/Star";

export const InlinePriceIndicator = ({ style = {} }) => (
  <StarIcon color="primary" style={style} />
);
